import type { TranslationKeys } from '$lib/server/translations/translations.service';
import { writable } from 'svelte/store';

export const translationsStore = writable({} as Partial<TranslationKeys>);
